module.exports = __webpack_public_path__ + "static/media/felipe.a8521129.png";